import { useEffect } from "react";

const ORIGIN = typeof window !== "undefined" ? window.location.origin : "";

function setMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

export function useSeo({ title, description, path, image, schema }) {
  const schemaStr = schema ? JSON.stringify(schema) : "";
  useEffect(() => {
    const fullTitle = title ? `${title}` : "Cirencester 4x4 | Specialist 4x4 & SUV Sales";
    document.title = fullTitle;
    const url = `${ORIGIN}${path ?? window.location.pathname}`;
    if (description) {
      setMeta("name", "description", description);
      setMeta("property", "og:description", description);
    }
    setMeta("property", "og:title", fullTitle);
    setMeta("property", "og:url", url);
    if (image) setMeta("property", "og:image", image.startsWith("http") ? image : `${ORIGIN}${image}`);
    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) {
      link = document.createElement("link");
      link.rel = "canonical";
      document.head.appendChild(link);
    }
    link.href = url;
    let script = null;
    if (schemaStr) {
      script = document.createElement("script");
      script.type = "application/ld+json";
      script.dataset.seo = "page";
      script.text = schemaStr;
      document.head.appendChild(script);
    }
    return () => { if (script) script.remove(); };
  }, [title, description, path, image, schemaStr]);
}

export function localBusinessSchema(site) {
  return {
    "@context": "https://schema.org",
    "@type": "AutoDealer",
    name: site.business_name,
    description: "Specialist used 4x4 and SUV sales in Cirencester, Gloucestershire.",
    url: ORIGIN,
    telephone: site.phone,
    email: site.email,
    image: `${ORIGIN}/img/hero.webp`,
    address: {
      "@type": "PostalAddress",
      streetAddress: [site.address_line1, site.address_line2].filter(Boolean).join(", "),
      addressLocality: site.town,
      addressRegion: site.county,
      postalCode: site.postcode,
      addressCountry: "GB",
    },
    areaServed: ["Cotswolds", "Gloucestershire", "Wiltshire", "Oxfordshire", "Cheltenham", "Swindon"],
    openingHours: (site.opening_hours || []).map((h) => h.schema).filter(Boolean),
  };
}
